module.exports = __webpack_public_path__ + "media/images/homes/CreateCustomerprofiles-29c64445b05f4a1bf73fdf0bbec13ea3.png";